import React, { useEffect, useState, useRef } from "react";
import Slider from 'react-slick';
import InView from 'react-intersection-observer';
import HeaderAnim from "../common/utils/animations/textRevealAnimation";
import { motion, useViewportScroll, useTransform } from 'framer-motion';
import { SlideInWithScroll } from "../common/utils/animations/slideInWithScroll";
import Parallax from "../common/utils/animations/parallax";
import { directions } from "../common/utils/animations/animationConstants";

const LogoAnim = ({ initial, final, getScrollValue, logo }) => {
  const { scrollY } = useViewportScroll();
  const triggerPoints = [0.45, 0.4, 0.35, 0.3, 0.25, 0.2, 0.15, 0.1, 0.05];
  const opacity = useTransform(scrollY,
    [getScrollValue(triggerPoints[initial]),
    getScrollValue(triggerPoints[final])],
    [0, 1], [0.42, 0, 0.58, 1]);
  return <motion.li
    key={initial}
    style={{ opacity }}
    className="col">
    {logo.icon}
    <img src={logo.image} title={logo.title} alt={logo.alt} />
  </motion.li>;
};

export default function HomeAccolades(props) {
  const [isMobile, setisMobile] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [isIconVisible, setIsIconVisible] = useState(false);
  const [elementTop, setElementTop] = useState(0);
  const [clientHeight, setClientHeight] = useState(0);
  const ref = useRef();
  const { scrollY } = useViewportScroll();
  const easing = [0.42, 0, 0.58, 1];

  const variants = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.1,
        ease: [0.42, 0, 0.58, 1],
        duration: 0.3
      },
    },
  };

  const setValues = () => {
    if (!ref.current) return;

    setisMobile(window.innerWidth <= 1023);
    setElementTop(ref.current.offsetTop);
    setClientHeight(window.innerHeight);
  };

  useEffect(() => {
    if (!ref.current) return;

    document.addEventListener('load', setValues);
    window.addEventListener('resize', setValues);

    return () => {
      document.removeEventListener('load', setValues);
      window.removeEventListener('resize', setValues);
    };
  });

  const getScrollPosition = (trigger) => {
    return elementTop - clientHeight * trigger;
  };
  const transformInitialValue = elementTop - clientHeight * 0.7;
  const transformFinalValue = elementTop;
  const yRange = [transformInitialValue, transformFinalValue];
  const opacity = useTransform(scrollY, yRange, [0, 1], easing);

  const scrollInitialValue = [elementTop - clientHeight * 0.65,
  elementTop - clientHeight * 0.55,
  elementTop - clientHeight * 0.45,
  elementTop - clientHeight * 0.40,
  elementTop - clientHeight * 0.35];
  const scrollFinalValue = elementTop - clientHeight * 0.30;

  const y1 = useTransform(scrollY, [scrollInitialValue[0], scrollFinalValue], [-50, 0], easing);
  const y1Op = useTransform(scrollY, [scrollInitialValue[0], scrollInitialValue[1]], [0, 1], easing);
  const y2 = useTransform(scrollY, [scrollInitialValue[1], scrollInitialValue[2]], [-50, 0], easing);
  const y2Op = useTransform(scrollY, [scrollInitialValue[1], scrollInitialValue[2]], [0, 1], easing);
  const y3 = useTransform(scrollY, [scrollInitialValue[2], scrollInitialValue[3]], [-50, 0], easing);
  const y3Op = useTransform(scrollY, [scrollInitialValue[2], scrollInitialValue[3]], [0, 1], easing);
  const y4 = useTransform(scrollY, [scrollInitialValue[3], scrollInitialValue[5]], [-50, 0], easing);
  const y4Op = useTransform(scrollY, [scrollInitialValue[3], scrollInitialValue[5]], [0, 1], easing);

  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    centerMode: true,
    variableWidth: true,
    autoplay: true,
    autoplaySpeed: 3000,
  };
  const { title, accoladesLogos } = props.data;

  const getScrollValue = (trigger) => {
    return elementTop - clientHeight * trigger;
  };

  const handleChange = (inView, entry) => {
    //threshold={[0.05, 0.1, 0.15, 0.2]}
    const { intersectionRect } = entry;
    if (inView && !isVisible) {
      setIsVisible(inView);
    } else if (!inView && isVisible && intersectionRect.top !== 0) {
      setIsVisible(inView);
    }
  };

  //const triggers = [0.82, 0.75, 0.70, 0.65, 0.60, 0.55, 0.50, 0.45, 0.4];
  const triggers = [[1, 0.95], [0.97, 0.92], [0.94, 0.89], [0.91, 0.86], [0.88, 0.83], [0.85, 0.8], [0.82, 0.77]];
  return (
    <InView as="div" className="section-gap text-center" onChange={handleChange} threshold={[0.4, 0.8]}>
      <div className="home-accolades-section section-gap" onLoad={setValues}>
        <div ref={ref} className="container">
          <div className="accolades-title">
            <p className="theme-color-title" style={{ minHeight: '26px' }}>{isVisible ? <HeaderAnim header={title} /> : ' '}</p>
          </div>
          <div className="accolades-logo-block">
            {!isMobile &&
              <ul
                className="row accolades-logo-list d-flex">
                {accoladesLogos.map((logo, i) => {
                  const jsx = <motion.li>
                    <img src={logo.image} title={logo.title} alt={logo.alt} />
                  </motion.li>;

                  return <Parallax key={i} id={"accolades-logo-" + i} direction={directions.LTR} length={25} opacity={true} triggers={triggers[i]}>
                    {jsx}
                  </Parallax> ;
                  //return <SlideInWithScroll elementTop={elementTop} clientHeight={clientHeight} children={jsx} triggerPoints={[triggers[i], triggers[i + 1]]} key={i} direction="BTT" />;
                })}
              </ul>}
            {isMobile && <>
              <ul className="row accolades-logo-list d-flex ">
                <Slider {...settings}>
                  {accoladesLogos.map((logo, i) =>
                    <li key={i}>
                      <img src={logo.image} title={logo.title} alt={logo.alt} />
                    </li>)}
                </Slider>
              </ul>
            </>}
          </div>
        </div>
      </div>
    </InView>
  );
}

